import { useState, useRef } from 'react';

const agentes = [
  {
    title: 'El Reclutador para Network Marketing',
    videoId: 'xiTKSh9cYug',
    tag: 'Network Marketing',
  },
  {
    title: 'Oficinas Legales',
    videoId: 'vk5Od2dRzjA',
    tag: 'Legal',
  },
  {
    title: 'Realtor Especialista en Bienes Raíces',
    videoId: 'MifwD2EkNzw',
    tag: 'Bienes Raíces',
  },
  {
    title: 'El Mentor Experto en Coaching y Mentoría',
    videoId: 'CfVszgt7f48',
    tag: 'Coaching',
  },
  {
    title: 'Agente de Voz para Clínicas',
    videoId: 'OR5JzbLNMnE',
    tag: 'Salud',
  },
  {
    title: 'Agente Especialista en Restaurantes',
    videoId: '2ELLnzYz-88',
    tag: 'Restaurantes',
  },
  {
    title: 'Agente para Tienda Naturista',
    videoId: 'S15VLMcQIjE',
    tag: 'Tienda Naturista',
  },
];

export default function EscuchaAgentes() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 340;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section
      id="escucha-agentes"
      className="py-24 bg-gradient-to-b from-[#1a1f3a] to-[#0a0e27] relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 30% 40%, cyan 1px, transparent 1px), radial-gradient(circle at 70% 60%, purple 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex items-end justify-between mb-12">
          <div>
            <p className="text-cyan-400 text-sm font-bold tracking-widest mb-4 uppercase">
              DEMOS EN VIVO
            </p>
            <h2 className="text-4xl md:text-5xl font-extrabold text-white leading-tight">
              Escucha Algunos de{' '}
              <span className="bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
                Nuestros Agentes de Voz
              </span>
            </h2>
          </div>
          <div className="hidden md:flex items-center gap-3">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-cyan-400 hover:bg-cyan-400/10 transition-all cursor-pointer whitespace-nowrap"
              aria-label="Anterior"
            >
              <i className="ri-arrow-left-s-line ri-lg" />
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-cyan-400 hover:bg-cyan-400/10 transition-all cursor-pointer whitespace-nowrap"
              aria-label="Siguiente"
            >
              <i className="ri-arrow-right-s-line ri-lg" />
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-6 scrollbar-hide snap-x snap-mandatory"
          style={{
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          {agentes.map((agente, index) => (
            <div
              key={index}
              className="flex-shrink-0 snap-start group"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className="relative rounded-2xl overflow-hidden border-2 transition-all duration-500 ease-out"
                style={{
                  width: '300px',
                  height: '534px',
                  borderColor:
                    hoveredIndex === index
                      ? 'rgba(6, 182, 212, 0.6)'
                      : 'rgba(6, 182, 212, 0.15)',
                  boxShadow:
                    hoveredIndex === index
                      ? '0 0 40px rgba(6, 182, 212, 0.3), 0 25px 50px rgba(0,0,0,0.5)'
                      : '0 10px 30px rgba(0,0,0,0.3)',
                  transform:
                    hoveredIndex === index
                      ? 'scale(1.05)'
                      : 'scale(1)',
                }}
              >
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube.com/embed/${agente.videoId}`}
                  title={agente.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />

                <div
                  className="absolute bottom-0 left-0 right-0 p-4 transition-opacity duration-300 pointer-events-none"
                  style={{
                    background: 'linear-gradient(to top, rgba(0,0,0,0.9) 0%, transparent 100%)',
                    opacity: hoveredIndex === index ? 1 : 0.7,
                  }}
                >
                  <span className="inline-block px-2.5 py-1 text-[10px] font-bold tracking-wider uppercase rounded-full bg-cyan-500/20 text-cyan-300 border border-cyan-500/30 mb-2">
                    {agente.tag}
                  </span>
                  <h3 className="text-sm font-bold text-white leading-snug">
                    {agente.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex md:hidden items-center justify-center gap-3 mt-6">
          <button
            onClick={() => scroll('left')}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-cyan-400 transition-all cursor-pointer whitespace-nowrap"
            aria-label="Anterior"
          >
            <i className="ri-arrow-left-s-line ri-lg" />
          </button>
          <button
            onClick={() => scroll('right')}
            className="w-10 h-10 flex items-center justify-center rounded-full border border-white/20 text-white/60 hover:text-white hover:border-cyan-400 transition-all cursor-pointer whitespace-nowrap"
            aria-label="Siguiente"
          >
            <i className="ri-arrow-right-s-line ri-lg" />
          </button>
        </div>

        {/* WhatsApp Button */}
        <div className="flex justify-center mt-12">
          <a
            href="https://wa.link/5m9j40"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full font-bold text-white text-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl cursor-pointer whitespace-nowrap"
            style={{
              background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
              boxShadow: '0 8px 32px rgba(37, 211, 102, 0.35)',
            }}
          >
            <i className="ri-whatsapp-line text-2xl" />
            Escríbenos por WhatsApp
          </a>
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </section>
  );
}
